export default {"src":"/_next/static/media/timeline-arrow-right-unpainted.f6a364f5.svg","height":10,"width":14};